import { forwardRef, useMemo } from 'react';
import { sanitizeHtml } from '@/entities/policy';

interface PolicyContentProps {
  html: string;
  className?: string;
  compact?: boolean;
}

export const PolicyContent = forwardRef<HTMLDivElement, PolicyContentProps>(
  function PolicyContent({ html, className, compact = false }, ref) {
    // Memoize sanitization to avoid re-running on parent re-renders
    const sanitizedHtml = useMemo(() => sanitizeHtml(html), [html]);

    return (
      <div
        ref={ref}
        className={className}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
        style={{
          height: compact ? 'min(46vh, 420px)' : '50vh',
          maxHeight: compact ? '46vh' : '50vh',
          overflowY: 'scroll', // 'scroll' always shows track, ensures this div owns the scroll
          overflowX: 'hidden',
          padding: compact ? '14px' : '16px',
          border: '1px solid #d9d9d9',
          borderRadius: "var(--radius-sm)",
          overscrollBehavior: 'contain', // prevent scroll from bubbling to modal
          fontSize: compact ? '13px' : undefined,
          lineHeight: compact ? 1.55 : undefined,
        }}
      />
    );
  },
);
